import axios from 'axios';

import { getFormDataObject } from 'src/helpers/fileUploadHelper';
import type {
	AllLocationMappingsResponse,
	FetchMappingFieldsResponse,
	HeaderFieldsResponse,
	LocationMappingFetchResponse,
	LocationMappingInput,
	LocationMappingResponse,
} from 'src/interfaces/LocationMapping';
import type { Pagination } from 'src/interfaces/Pagination';
import type { Response } from 'src/interfaces/Response';
import type { SovosUploadFile } from 'src/interfaces/SovosUploadFile';

function createApiUri(path: string = '') {
	return '/api/gtdcm/v1/location-templates' + path;
}

export const fetchAllLocationMappingsUri = createApiUri('/all');

export async function fetchAllLocationMappings() {
	const response = await axios.get<AllLocationMappingsResponse>(
		fetchAllLocationMappingsUri
	);

	return response.data.data;
}

export const fetchLocationMappings = async (pagination: Pagination) => {
	const response = await axios.get<LocationMappingFetchResponse>(
		createApiUri(`?page=${pagination.page}&perPage=${pagination.perPage}`)
	);

	return response.data.data;
};

export const fetchMappingFields = async () => {
	const response = await axios.get<FetchMappingFieldsResponse>(
		createApiUri('/get-mapping-fields')
	);

	return response.data.data;
};

export const uploadFile = async (files: SovosUploadFile[]) => {
	const response = await axios.post<HeaderFieldsResponse>(
		createApiUri('/get-header-fields'),
		getFormDataObject(files)
	);

	return response.data.data;
};

export const checkNameNewLocationMapping = async (fileName: string) => {
	const response = await axios.get<Response<boolean>>(
		createApiUri(`/check-name/${fileName}`)
	);

	return response.data.data;
};

export const fetchLocationMapping = async (locationMappingID: number) => {
	const response = await axios.get<LocationMappingResponse>(
		createApiUri(`/${locationMappingID}`)
	);

	return response.data.data;
};

export const saveLocationMapping = async ({
	rowsContent = [],
	...data
}: LocationMappingInput) => {
	const locationMapping = {
		...data,
		rowsContent,
	};

	const response = await axios.post<LocationMappingResponse>(
		createApiUri(),
		locationMapping
	);

	return response.data.data;
};

export const updateLocationMapping = async (
	id: number,
	{ rowsContent = [], ...data }: LocationMappingInput
) => {
	const locationMapping = {
		id,
		rowsContent,
		...data,
	};

	const response = await axios.put<LocationMappingResponse>(
		createApiUri(),
		locationMapping
	);

	return response.data.data;
};

export const deleteLocationMapping = async (locationMappingsIds: number[]) => {
	const response = await axios.post<LocationMappingResponse>(
		createApiUri('/delete'),
		locationMappingsIds
	);

	return response.data.data;
};
